import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core'
import { MatSlideToggle } from '@angular/material/slide-toggle'
import { TranslatePipe } from '@ngx-translate/core'
import { FormsModule } from '@angular/forms'
import { CallJoinSettings } from '../users.service'
import { Organization } from '../organizations.service'

@Component({
  selector: 'app-join-settings',
  standalone: true,
  imports: [MatSlideToggle, TranslatePipe, FormsModule],
  templateUrl: './join-settings.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './join-settings.component.scss',
})
export class JoinSettingsComponent {
  @Input({ required: true })
  data!: CallJoinSettings

  @Input()
  disabled = false

  @Input()
  organization!: Organization

  @Output()
  update = new EventEmitter<void>()
}
